import { Component, TemplateRef, ViewChild, OnDestroy, OnInit, ApplicationRef } from '@angular/core';
import { Subscription, interval, concat } from 'rxjs';
import { ModalService } from '@services/support/modal.service';
import { FlashMessagesService } from '@mobilestar/ngx-flash-messages';
import { SwUpdate } from '@angular/service-worker';
import { LoaderService } from '@services/support/loader.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '@services/account.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild("updateTemplate", { static: true }) private updateTemplate: TemplateRef<any>;

  availableSub: Subscription = null;
  checkUpdateSub: Subscription = null;

  constructor(
    accountService: AccountService,

    private titleService: Title,
    private translateService: TranslateService,
    private loaderService: LoaderService,
    private modalService: ModalService,
    private flashMessages: FlashMessagesService,
    private SWUpdate: SwUpdate,
    private applicationRef: ApplicationRef
  ) { }

  ngOnInit() {
    const loadTime = Date.now();

    // Set title depend on language
    this.translateService.onLangChange.subscribe(change => {
      this.titleService.setTitle(change.translations.TITLE);
    });

    // Set default language
    this.translateService.setDefaultLang('tr');
    this.translateService.setDefaultLang('en');

    // Set current language
    this.translateService.use('en');

    // Check for updates every minute
    const isStable = this.applicationRef.isStable.pipe(first(s => s === true));
    const everyMinute = interval(60000);
    this.checkUpdateSub = concat(isStable, everyMinute).subscribe(() => {
      this.SWUpdate.checkForUpdate();
    });

    this.SWUpdate.available.subscribe(event => {
      if (Date.now() - loadTime < 5000) {
        this.SWUpdate.activateUpdate().then(() => document.location.reload());
      } else {
        const modalId = this.modalService.show({
          template: this.updateTemplate,
          context: {
            dataModel: null,
            callbacks: {
              update: () => {
                this.modalService.hide(modalId);
                this.loaderService.show();
                this.SWUpdate.activateUpdate()
                .then(() => document.location.reload())
                .catch(error => {
                  this.loaderService.hide();
                  this.flashMessages.show('Update failed', { cssClass: 'alert-danger', timeout: 10000, closeOnClick: true });
                });
              }
            }
          }
        });
      }
      
    });
  }

  ngOnDestroy() {
    if (this.availableSub) { this.availableSub.unsubscribe() }
  }
}
